import { useState } from 'react';
import img1 from '../Components/Images/antennas/rf1.png'
import img2 from '../Components/Images/antennas/rf2.png'
import img3 from '../Components/Images/antennas/rf3.png'
import img4 from '../Components/Images/antennas/rf4.png'

import './zartecbutton.css'
import './AM_antenna.css'
export default function RF_antennas() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  // Sample product data - replace with your actual products
  const products = [
    {
      id: 1,
      name: "PLEXUS RF40",
      category: "Premium",
      image: img1,
      description: "The PLEXUS system is a full body acrylic pedestal. Because of its maximum transparency, it perfectly blends into all store interiors, where it will non-obtrusively fulfill its security task.",
      details: [
        "Remote service enabled",
        "Transparent panels",
        "Compatible with analytics",
        "Jammer detection"
      ],
      rating :5
    },
    {
      id: 2,
      name: "FORTUS RF40",
      category: "High-End",
      image: img2,
      description: "Designed for tough environments like DIY-stores and supermarkets, yet still with class and style. Meet the FORTUS RF40.",
      details: [
        "Integrated visitor count",
        "Compatible with analytics",
        "Optional advertising",
        "Integrated doorbell"
      ],
      rating :5
    },
    {
      id: 3,
      name: "NEXUS RF30",
      category: "High-End",
      image: img3,
      description: "NEXUS RF30 systems are aesthetically superior, match perfectly with your store interior and fulfill their task non-obstructively.",
      details: [
        "Optional advertising",
        "Alarm lights: Multicolor",
        "Integrated doorbell",
        "Jammer detection"
      ],
      rating :4
    },
    {
        id: 4,
        name: "FORTUS RFM40",
        category: "High-End",
        image: img4,
        description: "The FORTUS RFM40 pulse-listening mono system is a Retail Loss Prevention system that offers premium security in a modern and solid jacket, designed and optimized for maximum performance in any retail environment.",
        details: [
          "Distinguish in/out alarms",
          "Integrated doorbell",
          "Optional advertising",
          "Remote service enabled"
        ],
        rating :4
      }
      
      
  ];

  const handleProductClick = (productId) => {
    setSelectedProduct(productId === selectedProduct ? null : productId);
  };

  return (
    <div className="container ">
      <div className="row product-grid ">
        {products.map(product => (
          <div key={product.id} className="">
            {/* col-md-3 mb-4 */}
            <div 
              className={`product-card ${selectedProduct === product.id ? 'selected' : ''}`}
              onClick={() => handleProductClick(product.id)}
            >
                {/* card content */}
            
            <div className="card-content" onClick={() => handleProductClick(product.id)}>  
              {/* Category Badge */}
              <div className="category-badge">{product.category}</div>
              
              {/* Product Name */}
              <h3 className="product-name">{product.name}</h3>
              
              {/* Product Image */}
              <div className="product-image-container">
                <img src={product.image} alt={product.name} className="product-image" loading="lazy"  />
              </div>
              
              {/* Product Description */}
              <div className="product-description">
                <p>{product.description}</p>
              </div>
              
              {/* Product Details */}
              <div className="product-details">
                <h5>Highlights</h5>
                <ul>
                  {product.details.map((detail, index) => (
                    <li key={index}>
                      <span className="detail-bullet">•</span> {detail}
                    </li>
                  ))}
                </ul>
              </div>
              <div className='text-center'>

                            {[...Array(5)].map((_, index) => (
                <span key={index} style={{ color: index < product.rating ? '#006672' : '#ccc', fontSize: '20px' }}>
                    ★
                </span>
                ))} 
                </div>   
              </div>
              
              {/* Action Button */}
             
              
              <div className='text-center'>
                <button className='btn zartec-btn zartec-btn-primary zartec-btn-small'>Get Product</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* CSS Styling */}
            <style jsx>{`

            .product-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 15px;
            }

            `}</style>
    </div>
  );
}

